import { MyLanguagesDocument, MyChannelsDocument } from '~/graphql/operations'
import type { Client } from 'urql'
import type { Pinia } from 'pinia'

export default defineNuxtRouteMiddleware(async (to, from) => {
  const { $pinia, $urql } = useNuxtApp()
  const store = useStore($pinia as Pinia)

  if (to.path === '/403') {
    return
  }

  try {
    // Get Channels from JWT token
    if (!store.channels && store.auth?.user?.userChannels?.length) {
      store.channels =
        store.auth?.user?.userChannels.map((channel) => ({
          ...channel,
          name:
            channel.id === 1
              ? channel.name.replace(' (Default)', '')
              : channel.name,
          id: +channel.id,
        })) || []
    }

    if (!store.channels?.length && store.auth?.authToken) {
      const channels = await ($urql as Client)
        .query(MyChannelsDocument, {})
        .toPromise()

      store.channels = channels.data?.myChannels.map((c) => ({
        id: c.id,
        name: c.name,
        stockPoolId: c.stockPool.id,
        defaultLanguageId: c.defaultLanguageId,
      }))
    }
  } catch (e) {
    console.warn('[Init] Failed to get channels.')
  }

  try {
    if (
      (!store.languages || !store.languages.length) &&
      store.auth?.authToken
    ) {
      const languages = await ($urql as Client)
        .query(MyLanguagesDocument, {})
        .toPromise()
      store.languages = languages.data?.myLanguages.map((item) => ({
        ...item,
        id: +item.id,
      }))
    }
  } catch (e) {
    console.warn('[Init] Failed to get languagess. Using fallback values')
    store.languages =
      store.auth?.user?.userChannels.map((uc) => ({
        id: uc.defaultLanguageId,
        name: 'Fallback',
      })) || null
  }
})
